import { inject, observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ApplicationStoreType } from 'models/ApplicationStore';

import GenericErrorComponent from 'components/InfoBoxComponent/GenericErrorComponent';
import LoadingOverlayComponent from 'components/LoadingOverlayComponent';

import Headline from 'elements/Headline';

import HeaderComponent from 'components/HeaderComponent/HeaderComponent';
import PageStackBlock from 'components/PageStackBlock/PageStackBlock';
import { ROUTE_HOME } from 'utils/constants/routes';
import { HistoryProps, paramFromMatch } from 'utils/history';

interface AuthorizeScreenProps {
  applicationStore: ApplicationStoreType;
}

@inject('applicationStore')
@observer
class AuthorizeScreen extends React.Component<AuthorizeScreenProps & HistoryProps> {
  componentDidMount() {
    this.authorize(paramFromMatch(this.props.match, 'token'));
  }

  componentDidUpdate(prevProps: HistoryProps) {
    const newToken = paramFromMatch(this.props.match, 'token');

    if (!newToken) {
      return;
    }

    if (newToken !== paramFromMatch(prevProps.match, 'token')) {
      this.authorize(newToken);
    }
  }

  authorize(token?: string | null) {
    if (!token) {
      // wtf!?
      this.props.history.replace(ROUTE_HOME);
      return;
    }

    const searchParams = new URLSearchParams(this.props.location.search);
    const textileOrder = searchParams.get('textile_order');

    this.props.applicationStore.authenticate(token, textileOrder);
  }

  renderPage(content: any) {
    return (
      <>
        <HeaderComponent linkHome={'/'} noAccount={true} nolinkProjects={true} />

        <Headline.Large>
          <FormattedMessage id="Login" />
        </Headline.Large>

        <PageStackBlock>
          {content}
        </PageStackBlock>
      </>
    );
  }

  renderLoading() {
    return this.renderPage(<LoadingOverlayComponent />);
  }

  renderError() {
    const token = paramFromMatch(this.props.match, 'token');

    let retry;
    if (token) {
      retry = () => this.authorize(token);
    }

    return this.renderPage(<GenericErrorComponent onRetryClick={retry} />);
  }

  render() {
    const { applicationStore } = this.props;

    if (applicationStore.isAuthenticating) {
      return this.renderLoading();
    }

    if (applicationStore.authState && applicationStore.authState.error === 'login_error') {
      return this.renderError();
    }

    // any other authentication result will lead to a redirect so we do not need to render anything
    return null;
  }
}

export default AuthorizeScreen;
